import { Widget, WidgetHeader, WidgetBody } from "../../ui/Widget"
import useStore from "../../../store"
import { useEffect, useState } from "react"
import GoogleMapsAddressLink from "../../common/GoogleMapsAddressLink"
import phoneNumber from "../../../utilities/phoneNumber"
import { FaPlusCircle } from "react-icons/fa"
import ReusableDrawer from "../../common/ReusableDrawer"
import DealerPlaceForm from "./DealerPlaceForm"
import PlaceTypeIcon from "./PlaceTypeIcon"

export default function DealerPlaces({ dealerId }) {
  const { dealerPlaces, fetchDealerPlaces, dealer } = useStore((state) => state)
  const [isFetching, setIsFetching] = useState(false)
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    setIsFetching(true)
    fetchDealerPlaces(dealerId, () => setIsFetching(false))
  }, [dealerId])

  return(
    <Widget>
      <WidgetHeader
        title="Dealer Places"
        showSpinner={isFetching}
        actionIcon={
          <FaPlusCircle
            className="w-6 h-6 hover:cursor-pointer"
            onClick={() => setIsOpen(true)}
          />
        }
      />
      <WidgetBody
        isVisible={
          !!dealerPlaces &&
          dealer.attributes['line-ids'].includes(dealerPlaces[0]?.attributes['dealer-id'])
        }
      >
        {dealerPlaces?.map((place) => (
          <div
            className='flex w-full items-center border-b-2 border-grey-700
              p-2 text-grey-300 text-left lg:hover:bg-grey-700 hover:cursor-pointer'
          >
            <div
              className="flex flex-col w-1/2 md:w-2/3"
            >
              {place.attributes['name'] &&
                <div className="font-bold text-lg text-grey-100">
                  {place.attributes['name']}
                </div>
              }

              <div className={`flex items-center gap-1.5 ${place.attributes['name'] ? "text-sm font-semibold text-grey-100" : "font-bold text-lg text-grey-100"}`}>
                <PlaceTypeIcon placeTypeName={place.attributes['place-type-name']} className="w-4 h-4" />
                {place.attributes['place-type-name']}
              </div>

              <div className="text-sm">
                {place.attributes['address1']}
                {place.attributes['address2'] && `, ${place.attributes['address2']}`}
                {place.attributes['city'] && `, ${place.attributes['city']}`}
                {place.attributes['state'] && `, ${place.attributes['state']}`}
                {place.attributes['zip'] && `, ${place.attributes['zip']}`}
              </div>

              {place.attributes['phone'] &&
                <div className="text-sm">
                  <a
                    href={`tel:${place.attributes['phone']}`}
                    className="underline hover:cursor-pointer"
                  >
                    {phoneNumber(place.attributes['phone'])}
                  </a>
                </div>
              }
            </div>
            <div className="flex justify-end w-1/2 md:w-1/3">
              <GoogleMapsAddressLink
                address={`${place.attributes['address1']}, ${place.attributes['city']}, ${place.attributes['state']} ${place.attributes['zip']}`}
                linkText="Google Maps"
              />
            </div>
          </div>
        ))}
      </WidgetBody>
      <ReusableDrawer
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title="Add Dealer Place"
        placement="bottom"
      >
        <DealerPlaceForm dealerId={dealerId} onClose={() => setIsOpen(false)} />
      </ReusableDrawer>
    </Widget>
  )
}